<template>
    <div>
        <h5 class="heading-1 mb-4">
            <span>OCORRÊNCIAS</span>
        </h5>
        <app-tabela
            :itens="problemas"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
            :bordered="false"
            :small="false"
        >
        </app-tabela>
    </div>
</template>

<script>

export default {
    props: {
        problemas: {
            type: Array,
            default: () => ([])
        }
    },

    data() {
        return {
            erros: [],
            campos: [

                {
                    key: 'sequencial',
                    label: 'Sequencial',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'problema',
                    label: 'Problema',
                    sortable: true,
                    filterable: true
                }
            ],
            itensPorPagina: 10
        }
    }
}


</script>
